import hand from '../../../assets/pictures/pictos/contributor/hand.png'
import crown from '../../../assets/pictures/pictos/contributor/crown.png'
import billets from '../../../assets/pictures/pictos/contributor/billets.png'
import goutte from '../../../assets/pictures/pictos/contributor/goutte.png'
import prog from '../../../assets/pictures/pictos/contributor/prog.png'
import dba from '../../../assets/pictures/pictos/contributor/dba.png'
import dsi from '../../../assets/pictures/pictos/contributor/dsi.png'
import chantier from '../../../assets/pictures/pictos/contributor/chantier.png'
import pdg from '../../../assets/pictures/pictos/contributor/pdg.png'
import compta from '../../../assets/pictures/pictos/contributor/compta.png'
import labo from '../../../assets/pictures/pictos/contributor/labo.png'
import kwak from '../../../assets/pictures/pictos/contributor/kwak.png'

export const CONTRIBUTOR_TYPES = [
    { id: 'PRINCIPAL', label: 'Interlocuteur principal', img: hand },
    { id: 'CHIEF', label: 'Chef de projet', img: crown },
    { id: 'COMMERCIAL', label: 'Commercial', img: billets },
    { id: 'HYDRO', label: 'Hydrogéologue', img: goutte },
    { id: 'DEV', label: 'Développeur', img: prog },
    { id: 'DBA', label: 'DBA (Administrateur de base de données)', img: dba },
    { id: 'DSI', label: 'DSI (Directeur du service Informatique)', img: dsi },
    { id: 'ARCHI', label: 'Architecte système / Administrateur', img: chantier },
    { id: 'DIRECTOR', label: 'Directeur', img: pdg },
    { id: 'COMPTA', label: 'Compta', img: compta },
    { id: 'CONTRIB', label: 'Contributeur' },
    { id: 'SCIENTIST', label: 'Chercheur', img: labo },
    { id: 'SUPPORT', label: 'Support', img: kwak },
    { id: 'OTHER', label: 'Autre' },
]